import React from 'react';
import toast from 'react-hot-toast';
import { TriangleAlert, Check, Info, AlertCircle } from 'lucide-react';

const whiteToastStyle = {
    marginTop: '40px',
    background: '#FFFFFF',
    border: '1px solid #E5E7EB',
    color: '#1F2937',
    borderRadius: '0.5rem',
    padding: '12px 16px',
    fontSize: '14px',
    minWidth: '280px',
    maxWidth: '350px',
    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)'
};

const errorToastStyle = {
    marginTop: '40px',
    maxWidth: '350px',
};

export const showError = (message) => {
    toast.dismiss();
    return toast.error(
        <div className="text-left w-full">{message}</div>,
        {
            icon: <TriangleAlert className="w-5 h-5" style={{ color: '#991B1B', strokeWidth: 1.5 }} />,
            style: errorToastStyle
        }
    );
};

export const showSuccess = (message) => {
    toast.dismiss();
    return toast(
        <div className="text-left w-full">{message}</div>,
        {
            icon: <Check className="w-5 h-5" style={{ color: '#059669', strokeWidth: 1.5 }} />,
            style: whiteToastStyle
        }
    );
};

export const showInfo = (message) => {
    toast.dismiss();
    return toast(
        <div className="text-left w-full">{message}</div>,
        {
            icon: <Info className="w-5 h-5" style={{ color: '#2563EB', strokeWidth: 1.5 }} />,
            style: whiteToastStyle
        }
    );
};

export const showLoading = (message) => {
    toast.dismiss();
    return toast.loading(
        <div className="text-left w-full">{message}</div>,
        {
            style: whiteToastStyle
        }
    );
};

export const dismissToast = (id) => toast.dismiss(id);

export const showWarning = (message) => {
    toast.dismiss();
    return toast(
        <div className="text-left w-full">{message}</div>,
        {
            icon: <AlertCircle className="w-5 h-5" style={{ color: '#D97706', strokeWidth: 1.5 }} />,
            style: whiteToastStyle
        }
    );
};
